const BASE_PATH = "/bc-protocol-deployment-fe"; // TODO: replace base path for your MFE

export { BASE_PATH };

export const routePaths = {
  dashboard: BASE_PATH,
  dsApps: `${BASE_PATH}/ds-apps`,
  templates: `${BASE_PATH}/templates`,
  thirdPartyContracts: `${BASE_PATH}/third-party-contracts`,
  deployments: `${BASE_PATH}/deployments`,
  deploymentCreate: `${BASE_PATH}/deployments/create`,
  deploymentLogs: (id: string) => `${BASE_PATH}/deployments/${id}/logs`,
};
